import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { Box, Typography, Button, CircularProgress } from "@material-ui/core";
import { useIntl } from "react-intl";
import { messages } from "../../messages";
import { useTenantImage } from "@ploy-ui/tenants";
import OfferSection from "./OfferSection";
import PaymentInfoSection from "./PaymentInfoSection";
import { fetchBuyoutPrices, fetchPaymentInformation } from "../../endpoints/CoreBuyout";
import BuyoutPriceTable from "./BuyoutPriceTable";
import clsx from "clsx";
const BuyoutSection = ({ availableForAutomaticBuyoutPrice, classes, paymentInfo, setPaymentInfo, applicationNumber, application, setShowEmailSlidein }) => {
    const buttonRef = useRef(null);
    const intl = useIntl();
    const taxNoteIcon = useTenantImage("TaxNoteIcon");
    const [offerReady, setOfferReady] = useState(false);
    const [buyoutPrices, setBuyoutPrices] = useState([]);
    const [buyoutPricesLoading, setBuyoutPricesLoading] = useState(false);
    const [selectedCell, setSelectedCell] = useState(null);
    const [loading, setLoading] = useState(false);
    const getNewBuyoutPrices = () => {
        setBuyoutPricesLoading(true);
        setBuyoutPrices([]);
        setPaymentInfo(null);
        getBuyoutPrices();
        setOfferReady(false);
    };
    const getBuyoutPrices = () => {
        if (!applicationNumber)
            return;
        setBuyoutPricesLoading(true);
        fetchBuyoutPrices(applicationNumber)
            .then(res => {
            if (res.success) {
                setBuyoutPrices(res.data.Result.BuyoutPriceList);
            }
            else {
                setBuyoutPrices([]);
            }
        })
            .finally(() => {
            setBuyoutPricesLoading(false);
        });
    };
    const fetchPaymentInfo = async (buyoutDate, newAgreement) => {
        if (!applicationNumber)
            return;
        const data = await fetchPaymentInformation(applicationNumber, buyoutDate, newAgreement);
        if (data.success) {
            setPaymentInfo(data.data);
            return data;
        }
        return null;
    };
    const handleGenerateOffer = async () => {
        setLoading(true);
        if (fetchPaymentInfo && buyoutPrices && selectedCell) {
            await fetchPaymentInfo(buyoutPrices[selectedCell.row].BuyoutDate, selectedCell?.col === 0 ? true : false);
        }
        setLoading(false);
        setOfferReady(true);
    };
    const handleCopy = (value) => {
        navigator.clipboard.writeText(value);
    };
    return (_jsxs(Box, { className: classes.card, children: [_jsx(Typography, { className: classes.sectionTitle, children: intl.formatMessage(messages.buyout) }), _jsxs(Box, { className: classes.buyoutTextAndButton, children: [_jsx("img", { src: taxNoteIcon ?? undefined, className: classes.icon, alt: "Tax Note" }), _jsx(Typography, { className: classes.infoText, children: availableForAutomaticBuyoutPrice
                            ? intl.formatMessage(messages.buyoutInfoText)
                            : intl.formatMessage(messages.buyoutContactForBuyout) }), _jsxs(Box, { children: [buyoutPrices.length === 0 && !offerReady && (_jsx(Button, { variant: "outlined", className: classes.button, onClick: getBuyoutPrices, disabled: buyoutPricesLoading || !availableForAutomaticBuyoutPrice, ref: buttonRef, children: intl.formatMessage(messages.buyoutGetPrice) })), buyoutPrices.length > 0 && !buyoutPricesLoading && !offerReady && (_jsx(Button, { className: classes.button, variant: "outlined", disabled: !selectedCell || loading, onClick: handleGenerateOffer, children: loading
                                    ? intl.formatMessage(messages.slideinGenerating)
                                    : intl.formatMessage(messages.slideinGenerateOffer) })), offerReady && (_jsx(Button, { variant: "outlined", className: classes.button, onClick: getNewBuyoutPrices, disabled: buyoutPricesLoading || !availableForAutomaticBuyoutPrice, ref: buttonRef, children: intl.formatMessage(messages.buyoutGetNewPrice) }))] })] }), buyoutPricesLoading && (_jsx(Box, { className: classes.slideinContent, children: _jsx(CircularProgress, {}) })), application &&
                buyoutPrices.length > 0 &&
                !buyoutPricesLoading &&
                !offerReady && (_jsxs(Box, { className: classes.slideinContent, children: [_jsx(BuyoutPriceTable, { buyoutPrices: buyoutPrices, selectedCell: selectedCell, setSelectedCell: setSelectedCell, classes: classes, application: application }), _jsx(Typography, { className: clsx(classes.infoText, classes.infoTextBottom), children: intl.formatMessage(messages.slideinInfoText) })] })), offerReady && (_jsxs(_Fragment, { children: [_jsx(OfferSection, { setShowEmailSlidein: setShowEmailSlidein, classes: classes, paymentInfo: paymentInfo, applicationNumber: applicationNumber }), _jsx(PaymentInfoSection, { paymentInfo: paymentInfo, handleCopy: handleCopy, classes: classes, setShowEmailSlidein: setShowEmailSlidein })] }))] }));
};
export default BuyoutSection;
//# sourceMappingURL=BuyoutSection.js.map